'use strict';

import Axios from "axios";
import NProgress from 'nprogress';
import AuthCheck from '../Auth';

export default class Api {

    static get url() {
        return process.env.VUE_APP_API_URL + '/v1/';
    }

    static getAxios() {
        const token = AuthCheck.getToken();
        let headers = {
            'Content-Type': 'multipart/form-data',
        };
        if (token) {
            headers['Authorization'] = 'Bearer '.concat(token);
        }
        const instance = Axios.create({
            headers: headers,
        });

        instance.interceptors.request.use(config => {
            NProgress.start();
            return config;
        });

        instance.interceptors.response.use(response => {
            NProgress.done();
            return response;
        });

        return instance;
    }

}